import axios from "axios";

export default axios.create({
    baseURL:'',
    headers:{
        'Accept':'application/json',
        'Content-Type':'application/json'
    }
});

axios.interceptors.request.use(function(config){
    return config;
}, function(error){
    return Promise.reject(error);
})

axios.interceptors.response.use(function(response){
    return response;
}, function(error){
    return Promise.reject(error);
})


export const getConfig = async () => {
    return await axios.get("/liveConfig");
}